import { useLayoutEffect, useEffect } from 'react';

var useIsoMorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export { useIsoMorphicEffect };
//# sourceMappingURL=use-iso-morphic-effect.esm.js.map
